   import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message ,Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker, Select, DatePicker} from 'antd';
import ModalImage from "react-modal-image";
import { DownloadOutlined } from '@ant-design/icons';

import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import pdf from '../../assets/images/icon/pdf-image.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import search from '../../assets/images/icon/search.png';
import close from '../../assets/images/icon/delete.png';

import $ from 'jquery';
const { TextArea } = Input;
const { Panel } = Collapse;

const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

function get_url_name(str){
	var result = /[^/]*$/.exec(str)[0];
	return result;
}

const dateFormat = 'YYYY-MM-DD';
const currDate = new Date();
class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			title: '',
			children_id: 1,
			details: '',
			image: '',
			video: '',
			file: '',
			loading: false,
  		    iconLoading: false,
  		    is_important: 0,
  		    is_archive: 0,
  		    school_list: [],
  		    child_list: [],
			offset: 0,
			offset_1: 1,
            perPage: 1,
            currentPage: 0,
            total_data: 0,
			activePage:1,
			page:1,
			read_more: true,	
			from_date: currDate,
			to_date: currDate,
			activity: 'all',
		}
		
		this.goBack = this.goBack.bind(this);
		this.change_activity = this.change_activity.bind(this);
		this.search = this.search.bind(this);
		this.close = this.close.bind(this);
		this.onChangefrom_ = this.onChangefrom_.bind(this);
		this.onChangeto_ = this.onChangeto_.bind(this);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
		var storedArray = JSON.parse(localStorage.getItem("schoolData"))
		this.setState({ user_id : storedArray['data'][0]['user_id'],child_id : this.props.match.params.id, });
		this.checkData()
		}
	}
	
	checkData(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			let program_id = this.props.match.params.id;
			var offset=this.state.offset;
			var per_page=this.state.perPage;	
			var activity = this.state.activity;
			var from_date = this.state.from_date;
			var to_date = this.state.to_date;
			
			var app = {user_id : user_id,child_id:program_id,activity:activity,to_date:to_date,from_date:from_date}
			getData('erp/daily_report',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							child_list: result['data'],
						});
						if(result['data'].length>0){
							if(result['data'][0]['daily_report'].length>0){
								document.getElementById('error').innerHTML = '';
								document.getElementById('error_1').innerHTML = '';
							}else{
								document.getElementById('error').innerHTML = 'No Data Found on filtered date! ';
								document.getElementById('error_1').innerHTML = 'No Data Found on filtered date!';
							}
						}
						
					}else{
						this.setState({
							school_list: [],
							child_list: [],
							
						});
						
						document.getElementById('error').innerHTML = 'No Data Found ';
						document.getElementById('error_1').innerHTML = 'No Data Found ';
					}
				}
			});
	}
  }
  
  
  
 	
	get_product(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			let program_id = this.props.match.params.id;
			var offset=this.state.offset;
			var per_page=this.state.perPage;
			
			var app = {user_id : user_id,child_id:program_id,offset:offset,per_page:per_page}
			getData('erp/daily_report',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
				
						this.setState({
								school_list: [
							  ...this.state.school_list,
							  ...result['data'] 
							],
							loading_more: false,
							read_more: true,
							total_data: result['total_data'],
						});
									
					   var lenght = result['data'].length;
						if(lenght > 0){	
						}else{
							this.setState({
							   loading_more: false,
								read_more: false,
							});
						}
								
						
					}else{
						this.setState({
							school_list: [],
							
						});						
						document.getElementById('error').innerHTML = 'No Data Found ';
						document.getElementById('error_1').innerHTML = 'No Data Found ';
					}
				}
			});
	}
  } 
  
	
	handleSizeChange = e => {
		this.setState({ [e.target.name]: e.target.value });
	};
  
  
  
	handlePageChange=(page)=>{
		var pageNumber=page+1;
        const selectedPage = pageNumber;
		const xtra = parseInt(pageNumber) - 1 ;
        const offset = xtra * parseInt(this.state.perPage)
        const offset_1 = xtra * parseInt(this.state.perPage)

	    this.setState({
            currentPage: selectedPage,
            offset: offset,
            offset_1: offset,
			activePage:selectedPage,
        }, () => {
            this.get_product();
            //this.scrollTop();
        });
	}
  
  
    goBack(){
		window.location.href = '/parent-notes/index';
	}
	
	
	
	change_activity(event){
         this.setState({activity: event});
		 
     }

	onChangefrom_(time, timeString) {
	  this.setState({
		  from_date: timeString,
		});
	}
	
	onChangeto_(time, timeString) {
	  this.setState({
		  to_date: timeString,
		});
	}

	search(){
		this.setState({school_list: [],});
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'] });
			var user_id = storedArray['data'][0]['user_id'];
			let program_id = this.props.match.params.id;
			var offset=this.state.offset;
			var per_page=this.state.perPage;	
			var activity = this.state.activity;
			var from_date = this.state.from_date;
			var to_date = this.state.to_date;
			
			var app = {user_id : user_id,child_id:program_id,activity:activity,to_date:to_date,from_date:from_date}
			getData('erp/daily_report',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							school_list: result['data'],
							child_list: result['data'],
						});
				     	if(result['data'][0]['daily_report'].length>0){
							document.getElementById('error').innerHTML = '';
							document.getElementById('error_1').innerHTML = '';
						}else{
							document.getElementById('error').innerHTML = 'No Data Found on filtered date! ';
							document.getElementById('error_1').innerHTML = 'No Data Found on filtered date! ';
						}
						
					}else{
						this.setState({
							school_list: [],
							child_list: [],
							
						});
						
						document.getElementById('error').innerHTML = 'No Data Found ';
						document.getElementById('error_1').innerHTML = 'No Data Found ';
					}
				}
			});
		
	
	}
	
	close(){
		window.location.href = '/daily-report/daily-report/'+this.props.match.params.id;
		this.setState({activity:'',from_date:'',to_date:''});
	}
		
	

	render()

	{
	var lenght = this.state.school_list.length; 
	const { size } = this.state;
	const content = (
					  <div>
						<p className="center upload-img"><Tooltip placement="right" title="Audio"><img src={music} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Pdf"><img src={pdf_} class="" alt="image" /></Tooltip></p>
						<p className="center upload-img"><Tooltip placement="right" title="Image"><img src={image} class="" alt="image" /></Tooltip></p>
						
					  </div>
					);
	const radioStyle = {
		  display: 'block',
		  height: '30px',
		  lineHeight: '30px',
		};				
					
		return (
			<div class="mobile_view">
			
			<div id="main" class="bg-off">
         <div class="row">
		 {this.state.child_list.map((list) => (
		 <div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     
					  <div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">{list.first_name} {list.last_name} Daily Report</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   <li class="breadcrumb-item"><a href="/daily-report/index">Daily Report</a>
                           </li>
                           <li class="breadcrumb-item active">{list.first_name} {list.last_name} Daily Report 
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
			))}
			
			
			
			
            
			{this.state.school_list.map((list) => (
			<div class="col s12 m12 ex-padd">
            <div class="container ">
			   <div class="col s12 m12 mb-20 mt-10 card-content iq-card">
                  <section class="invoice-list-wrapper section food">
					
					<div class="desktop-view">
						<div class="col s12 m12 mb-20 pb-20 mh-500 flow-root">
							<div class="row">
							
							
								<div class="col m12 s12 view-Profile no-padd ">
										<div class="col m2 s6 mt-5">
											<label>From Date</label>
									        <DatePicker defaultValue={moment(currDate, dateFormat)} onChange={this.onChangefrom_} />
										</div>
										<div class="col m2 s6 mt-5">
											<label>To Date</label>
									        <DatePicker defaultValue={moment(currDate, dateFormat)} onChange={this.onChangeto_} />
										</div>
							
										<div class="col m4 s6 mt-5 mb-10">
											<label >Activity</label>
											<Select name="activity" placeholder="Activity" value={this.state.activity}  onChange={this.change_activity}>			
												<Select.Option value="all">All</Select.Option>
												<Select.Option value="dairy">Diary</Select.Option>
												<Select.Option value="food">Food</Select.Option>
												<Select.Option value="health">Health</Select.Option>
												<Select.Option value="observation">Observation</Select.Option>
												<Select.Option value="play_learn">Play & Learn</Select.Option>
												<Select.Option value="potty">Potty</Select.Option>
												<Select.Option value="star">Star</Select.Option>
												<Select.Option value="sleep">Sleep</Select.Option>
											</Select>
										</div>
									
									<div class="col m2 s6 mt-20 mb-20 center">
											<img src={search} class="history-img mt-5 cursor"  onClick={this.search} />
											<img src={close} class="history-img mt-5 cursor"  onClick={this.close} />
										</div>
										
								</div>		


								
							
							{list.daily_report.map((health) => (
							<div>
								<div class="col m12 s12 bb center image ">
									<div class="dailry-report mb-20 mt-20"><b class="bg-color-1">{health.added_date}</b></div>
								</div>
								
							{health.list.map((row) => (	
							<div class="col m12 s12 bb pb-20 mt-20 mt-20">
								<div class="col m1 s2 title pt-10 no-padd">
									<img src={row.image} class="atd-img" />
								</div>
								<div class="col m10 s10 title">
									<div class="notes-desc"><b>{row.title}</b> </div>
									<div class="notes-desc">{row.details}</div>
									<div class="notes-desc">{row.details_ex}</div>
									<div class="notes-desc">{row.added_time} <span class="right">{list.user_name}</span></div>
									<div class="notes-desc"></div>
									{(() => {
									if (row.attach==1) {
										return (
									<div class="col m12  s12 title no-padd">
										<Collapse  onChange={callback}>
										<Panel header="Attachments" classname="as" key="1">
													
											{(() => {
											if (row.audio.length>0) {
												return (													
												   <div class="col m12  s12 no-padd m-audio">
														{row.audio.map((audio) => (<>	
														<div class="dfs">
														 <audio width="350" height="250" controls >
															<source src={audio} type="audio/mpeg"/>
														 </audio>
														 </div>
														</>))}
													</div>	
													)
												}
											})()}		

										{(() => {
											if (row.file.length>0) {
												return (
											<div class="col m12  s12 no-padd  m-pdf">
												{row.file.map((file) => (<>
												<div class="dfs">
												<a href={file} class="daily-link"  target="_blank">
												<Button type="primary">
												 Download PDF
												</Button>
												</a>	
												</div>									
												</>))}
											</div>	
											)
											}
										})()}		

											
										{(() => {
											if (row.img.length>0) {
												return (	
											<div class="col m12  s12 no-padd  m-img">
												{row.img.map((img) => (<>
												<div class="dfs">
												<ModalImage  small={img} large={img} hideDownload="true" />
												</div>
												</>))}
											</div>
											)
												}
											})()}		

											
											
										{(() => {
											if (row.video.length>0) {
												return (	
											<div class="col m12  s12 no-padd  m-video">
												{row.video.map((video) => (<>
												<div class="dfs">
												<video width="350" height="250" controls >
													<source src={video} type="video/mp4"/>
												</video>
												</div>
												</>))}
											</div>	
											)
												}
											})()}		

											
										
											</Panel>
											</Collapse>
										</div>
								     	)
									 }
									})()}
								</div>
								
							</div>	
							))}
							
							
							
							</div>	
							))}
							
							<p id="error" class="center mt-20 pt-150">Please Wait While Loading !!</p>
							

						
							
							
								
							</div>
						</div>	
					</div>	
					
					<div class="mobile-view">
						<div class="col s12 m12 mb-20 pb-20 add-notice mh-500 flow-root no-padd">
							<div class="row">
							
												
							
							{list.daily_report.map((health) => (
							<div>
								<div class="col m12 s12 bb center image">
									<div class="dailry-report mb-20 mt-10"><b class="bg-color-1">{health.added_date}</b></div>
								</div>
								
							
							{health.list.map((row) => (	
							<div class="col m12 s12 dialy-repot-div no-padd">
								<div class="col m1 s2 title mt-10  center no-padd">
									<img src={row.image} class="atd-img" />
								</div>
								<div class="col m10 s10 title no-padd">
									<div class="notes-desc"><b>{row.title}</b> </div>
									{list.details != '' ? <div class="notes-desc">{row.details}</div> :''}
									{list.details_ex != '' ? <div class="notes-desc">{row.details_ex}</div> :''}
									
									
									<div class="notes-desc">{row.added_time} <span class="right">{list.user_name}</span></div>
									
									{(() => {
									if (row.attach==1) {
										return (
												<div class="col m12  s12 title no-padd">
													<Collapse  onChange={callback}>
													<Panel header="Attachments" classname="as" key="1">
														<div class="col m12  s12no-padd">
															{row.img.map((img) => (
															<ModalImage  small={img} large={img} hideDownload="true" />
															))}
														</div>
														<div class="col m12  s12no-padd">
															{row.file.map((file) => (
															<a href={file} class="daily-link"  target="_blank">{file}</a>
															))}
														</div>
													</Panel>
													</Collapse>
												</div>
											)
										}
									})()}
								</div>
								
							</div>	
							))}
							
							
							
							</div>	
							))}
							
							<p id="error_1" class="center mt-20">Please Wait While Loading !!</p>
							
							
						
							
							
								
							</div>
						</div>	
					</div>
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
         </div>
		 ))}
		 
		 
		 
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
